/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Form, Tab, Tabs, Modal } from "react-bootstrap";
import LeftpanelMember from "../../../components/leftpanel/leftpanel-member";
import HeaderPart from "../../../components/layout/header/header";
import LoadingOverlay from "react-loading-overlay";
import "./my-account.css";
import countryConfig from "../../../config/country.config";
import axios from "../../../axios/axios";
import { message } from "antd";
import useFormValidation from "../../../hooks/useFormValidator";
import { products } from "../../../products/products.details";
import { useSelector, useDispatch } from "react-redux";
import { setSuccessCode } from "../../../actions/signUp.actions";
import DataTable from "react-data-table-component";
import moment from "moment";
import UpdateHirePlan from "../../signup/UpdateHirePlan";
import UpdatePlanLoveTravels from "../../signup/update-plan-love-travels";
import { useLocation } from "react-router-dom";
import { Dollars_Escape_Credits_white } from "../../../assets/images";
import { DATE_AND_TIME_FORMAT } from "../../../constants/constant";
import TransferEscapeBucksModal from "../../../components/TransferEscapeBucksModal";
import {
  setEscapeBuckRedeemModal,
  setApiCallForFetchingEscapeRedeemHistory,
} from "../../../actions/escapeBucks.actions";
import { CSVLink } from "react-csv";

const MyAccount = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const escapeParam = queryParams.get("escapeTab");
  const [transferModalShow, setTransferModalShow] = useState(false);
  const [user, setUser] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [affiliateDetails, setAffiliateDetails] = useState(null);
  const [allCals, setAllCals] = useState([]);
  const [escapeTotal, setEscapeTotal] = useState(0);
  const [escapeLimit, setEscapeLimit] = useState(10);
  const [escapePage, setEscapePage] = useState(1);

  // CHANGE PASSWORD
  const [new_pass, setNewPass] = useState("");
  const [con_pass, setConPass] = useState("");
  const [changePassError, setChangePasswordError] = useState("");

  const [loading, setLoading] = useState(false);

  const [saveCards, setSaveCards] = useState([]);

  // ADD NEW CARD
  const [card_holder_name, setCardHolderName] = useState("");
  const [card_number, setCardNumber] = useState("");
  const [exp_month, setExpMonth] = useState("");
  const [exp_year, setExpYear] = useState("");
  const [cvv, setCvv] = useState("");
  const [add_new_card, setNewCard] = useState(false);

  const [tabkey, setTabKey] = useState("profile");
  const [paypalId, setpaypalId] = useState("");
  const [commissionType, setcommissionType] = useState("");
  const [commissionTypeWiseSection, setcommissionTypeWiseSection] =
    useState(false);
  const [currentPlan, setCurrentPlan] = useState({});
  const [modalshow, setmodalshow] = useState(false);
  const [hitData, setHitData] = useState(false);
  const [modalshowUpdate, setmodalshowUpdate] = useState(false);
  const [modalPlan, setmodalPlan] = useState(false);

  const [validationReport, validate] = useFormValidation();

  const successModal = useSelector((state) => state.changeStep.successCode);
  const dispatch = useDispatch();
  const [allTransaction, setAllTransaction] = useState([]);
  const [allLastFourDigitCard, setAllLastFourDigitCard] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({
    totalPage: 1,
    totalRows: 1,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    type: "",
  });
  const [csvData, setCsvData] = useState([]);
  const escapeBuckTotalAmount = useSelector(
    (state) => state.escapeBucksRedux.escapeBuckAmount,
  );
  const escapeRedeemHistoryApiCall = useSelector(
    (state) => state.escapeBucksRedux.isApiCallForFetchingEscapeRedeemHistory,
  );
  const [menuPermission, setMenuPermission] = useState(null);

  const handleCloseTransferModal = () => setTransferModalShow(false);

  useEffect(() => {
    let data = localStorage.getItem("userDetails");
    if (data) {
      data = JSON.parse(data);
      getUserDetails(data.id);
      const serviceAccess = JSON.parse(localStorage.getItem("serviceAccess"));
      setMenuPermission(serviceAccess);
    }
  }, []);

  const getUserDetails = (id) => {
    setLoading(true);

    axios
      .get(`/user/${id}`)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const { data } = res.data;
          setUser(data);
          //getCustomerProductDetails(data.email)
          setName(data.name);
          setEmail(data.email);
          setPhone(data.phone);
          setAddress(data.address);
          setCity(data.city);
          setCountry(data.country);
          setState(data.state);
          setZipCode(data.zipCode);
          setpaypalId(data.paypalId);
          setUserName(data.userName);
          if (data.paypalId !== "") {
            setcommissionType("PayPal");
            setcommissionTypeWiseSection(true);
          }
          setAffiliateDetails(res.data?.affiliate);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const handleModalClose = () => {
    setmodalshow(false);
  };

  const handleModalCloseSuccess = () => {
    dispatch(setSuccessCode(false));
  };

  const handleModalCloseUpdate = () => {
    setmodalshowUpdate(false);
  };

  const handlePlanModalClose = () => {
    setmodalPlan(false);
  };
  const logout = async () => {
    localStorage.clear();
    message.warning("You are being logged out. Please wait...");
    window.open("/logout", "_self");
  };

  const handleCancelPlan = () => {
    setmodalshow(false);
    setLoading(true);
    axios
      .get(
        "/user/cancel-subscription/" +
        currentPlan.stripe_customer_id +
        "/tvi/" +
        currentPlan.id,
      )
      .then((res) => {
        setLoading(false);
        message.success(res.data.message);
        setHitData(true);
        logout();
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        message.error(err.message);
        setHitData(false);
      });
  };

  const changeTabKey = (key) => {
    if (key === "payment") {
      getAllCards(user);
      getAllTransaction(user, page, limit);
    }
    if (key === "escape") {
      fetchCals();
    }
    setTabKey(key);
  };

  const getCurrentPlan = (details) => {
    let { email, stripe_customer_id, isGlobalAidUser } = details;

    if (isGlobalAidUser === false && stripe_customer_id !== "") {
      setLoading(true);
      axios
        .get("/user/get-customer-current-plan/" + email)
        .then((res) => {
          setLoading(false);
          if (res.data.status) {
            setCurrentPlan(res.data);
          } else {
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  };

  const getAllCards = (details) => {
    let { source, stripe_customer_id } = details;

    setLoading(true);

    const formData = {
      source,
      stripe_customer_id,
    };

    axios
      .post("/user/get-user-all-cards-new", formData)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          let lastFourDigit = [];
          if (res.data.cards.length > 0) {
            for (let i = 0; i < res.data.cards.length; i++) {
              lastFourDigit.push(res.data.cards[i].card.last4);
            }
            setAllLastFourDigitCard(lastFourDigit);
          }
          setSaveCards(res.data.cards);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const updateUserDetails = (e) => {
    e.preventDefault();

    const formData = {
      name,
      email,
      phone,
      address,
      city,
      country,
      state,
      zipCode,
      id: user.id,
    };
    setLoading(true);
    axios
      .post("/user/update-user-details", formData)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success("Update Successfully.");
          localStorage.setItem("userDetails", JSON.stringify(res.data.data));
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const updatePassword = (e) => {
    e.preventDefault();

    if (new_pass !== con_pass) {
      setChangePasswordError("Confirm password not match");
      return;
    } else {
      setChangePasswordError("");
    }

    let formData = {
      id: user.id,
      email,
      password: new_pass,
    };
    setLoading(true);
    axios
      .post("/user/update-user-password", formData)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setNewPass("");
          setConPass("");
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const updatePaypalId = (e) => {
    e.preventDefault();

    let formData = {
      id: user.id,
      email,
      paypalId: paypalId,
      commissionType: commissionType,
    };
    setLoading(true);
    axios
      .post("/user/update-user-paypalid", formData)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success("Update Successfully.");
          localStorage.setItem("userDetails", JSON.stringify(res.data.data));
          setpaypalId(paypalId);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const addNewCard = (e) => {
    e.preventDefault();

    for (const [, value] of Object.entries(validationReport)) {
      if (!value.isValid) return;
    }

    const old_card = saveCards[0]?.id || null;

    const formData = {
      number: card_number,
      exp_month,
      exp_year,
      cvc: cvv,
      id: user.stripe_customer_id,
      old_card,
    };

    if (allLastFourDigitCard.includes(card_number.slice(-4))) {
      console.log("object", card_number.slice(-4));
      message.error("Card already exists");
      return;
    }

    setLoading(true);

    axios
      .post("/add-new-card-new", formData)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success("Card added Successfully");
          setNewCard(false);
          getAllCards(user);
        } else {
          message.error(res.data.message || res.data.error);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        message.error("Something Went Wrong!!!");
      });
  };

  const emptyField = () => {
    setCardHolderName("");
    setCardNumber("");
    setExpMonth("");
    setExpYear("");
    setExpYear("");
    setCvv("");
    setChangePasswordError("");
    setNewPass("");
    setConPass("");
  };

  const onChangeHandler = (e) => {
    let { name, value } = e.target;

    let rules = JSON.parse(e.target.dataset.rules);

    validate(value, rules, name);
  };

  const cancelCurrentPlan = () => {
    setmodalshow(true);
  };

  const updatePlan = () => {
    //history.push("/update-plan")
    setmodalshowUpdate(false);
    setmodalPlan(true);
  };

  const columns = [
    {
      name: "Type",
      selector: (row) => row.paymentType,
      width: "250px",
    },
    {
      name: "Amount",
      selector: (row) => "$" + row.amount,
      width: "150px",
    },
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("MM-DD-YYYY, hh:mm a"),
      width: "200px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      width: "150px",
    },
    {
      name: "Receipt",
      selector: (row) => (
        <>
          <a href={row.receipt_url} target="_blank" rel="noreferrer">
            Download
          </a>
        </>
      ),
      width: "150px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
  };

  const escapeColumns = [
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format(DATE_AND_TIME_FORMAT),
      sortable: true,
      wrap: true,
      style: {
        textAlign: "left",
        justifyContent: "flex-start",
      },
    },
    {
      name: "Type",
      selector: (row) =>
        row?.typeOfMode
          ? row?.typeOfMode == "transfer"
            ? row?.userId == user?._id
              ? "Credit Deducted"
              : "Credit Added"
            : "Code Redemption"
          : "Code Redemption",
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) =>
        row?.typeOfMode == "transfer" ? (
          <>
            {row?.userId == user?._id ? (
              <>
                <p style={{ color: "#e74c3c", fontWeight: "bold" }}>
                  -${row.amount}
                </p>
              </>
            ) : (
              <>
                <p style={{ color: "#26a69a", fontWeight: "bold" }}>
                  +${row.amount}
                </p>
              </>
            )}
          </>
        ) : (
          <>
            <p style={{ color: "#26a69a", fontWeight: "bold" }}>
              +${row.amount}
            </p>
          </>
        ),
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) =>
        row?.typeOfMode == "transfer" ? (
          <>
            <div className="desc-card">
              <div className="desc-section">
                <span className="label">From</span>
                <div className="value">
                  {row?.transferFromUserDetails?.name}
                </div>
                <div className="sub">{row?.transferFromUserDetails?.userName}</div>
              </div>

              <div className="arrow">→</div>

              <div className="desc-section">
                <span className="label">To</span>
                <div className="value">{row?.transferToUserDetails?.name}</div>
                <div className="sub">{row?.transferToUserDetails?.userName}</div>
              </div>
            </div>
          </>
        ) : (
          <>
            <p>{row.code}</p>
          </>
        ),
      style: {
        textAlign: "left",
        justifyContent: "flex-start",
      },
      sortable: true,
      wrap: true,
      grow: 3,
      minWidth: "300px",
    },
  ];

  const getAllTransaction = (details, page, limit) => {
    let { email } = details;
    setLoading(true);
    axios
      .get(
        `/user/get-all-transaction?page=${page}&limit=${limit}&email=${email}`,
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setAllTransaction(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const handlePageChange = (page) => {
    setPage(page);
    getAllTransaction(user, page, limit);
  };
  const handlePerRowsChange = (row) => {
    setLimit(row);
    getAllTransaction(user, page, row);
  };

  const fetchCals = async () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
      },
    };
    await axios
      .get(
        `/user/get-vip-user-code-redeem-list?page=${escapePage}&limit=${escapeLimit}&startDate=${filters.fromDate}&endDate=${filters.toDate}`,
        config,
      )
      .then((res) => {
        if (res.data.status) {
          setAllCals(res.data.data);
          setEscapeTotal(res.data.pagination?.totalRows);
          setEscapePage(parseInt(res.data.pagination?.page));
          setLoading(false);
        } else {
          setAllCals([]);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const fetchCalsReset = async () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
      },
    };
    await axios
      .get(`/user/get-vip-user-code-redeem-list?page=${1}&limit=${10}`, config)
      .then((res) => {
        if (res.data.status) {
          setAllCals(res.data.data);
          setEscapeTotal(res.data.pagination?.totalRows);
          setEscapePage(parseInt(res.data.pagination?.page));
          setLoading(false);
        } else {
          setAllCals([]);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const customStylesForEscape = {
    header: {
      style: {
        justifyContent: "left", // center | flex-start | flex-end
      },
    },
    headCells: {
      style: {
        fontWeight: "600",
      },
    },
  };
  const csvHeaders = [
    { label: "Date", key: "Date" },
    { label: "Type", key: "Type" },
    { label: "Amount", key: "Amount" },
    { label: "Description", key: "Description" },
  ];

  const handleDownloadCSV = async () => {
    setLoading(true);
    await axios
      .get(
        `/user/csv-vip-member-transaction-history/${user?._id}?startDate=${filters.fromDate}&endDate=${filters.toDate}`,
      )
      .then((res) => {
        if (res.data.status) {
          const csvData = res.data.data.map((row) => {
            const isTransfer = row?.typeOfMode === "transfer";
            const isSender = row?.userId === user?._id;

            return {
              Date: moment(row.createdAt).format(DATE_AND_TIME_FORMAT),

              Type: isTransfer
                ? isSender
                  ? "Credit Deducted"
                  : "Credit Added"
                : "Code Redemption",

              Amount: isTransfer
                ? isSender
                  ? `-${row.amount}`
                  : `+${row.amount}`
                : `+${row.amount}`,

              Description: isTransfer
                ? `From: ${row?.transferFromUserDetails?.name || "-"} (${row?.transferFromUserDetails?.userName || "-"
                }) 
To: ${row?.transferToUserDetails?.name || "-"} (${row?.transferToUserDetails?.userName || "-"
                })`
                : row?.code || "-",
            };
          });

          setCsvData(csvData);

          setTimeout(() => {
            document.getElementById("csv-download-link").click();
          }, 500);
          setLoading(false);
        } else {
          setCsvData([]);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (escapeParam === "1") {
      changeTabKey("escape");
    } else {
      changeTabKey("profile");
    }

  }, [escapeParam]);
  // useEffect(() => {
  //   if (escapeParam === "1") {
  //     if (menuPermission?.escape_credits) {
  //       changeTabKey("escape");
  //     } else {
  //       changeTabKey("profile");
  //       message.error(
  //         "You don't have permission to access Escape Credits tab.",
  //       );
  //     }
  //   }
  // }, [escapeParam]);

  useEffect(() => {
    if (escapeRedeemHistoryApiCall) {
      fetchCals();
      dispatch(setApiCallForFetchingEscapeRedeemHistory(false));
    }
  }, [escapeRedeemHistoryApiCall, dispatch, fetchCals]);

  const filterCallBack = useCallback(() => {
    fetchCals();
  }, [filters]);

  useEffect(() => {
    fetchCals();
  }, [escapeLimit, escapePage]);
  return (
    <div>
      <HeaderPart />
      <LoadingOverlay active={loading} spinner text="Loading ...">
        <div className="main_cont">
          <LeftpanelMember />
          <div className="right_cont">
            <div className="right_banner_banner_cnt">
              <div className="my_account_inner">
                <Tabs
                  defaultActiveKey="profile"
                  id="fill-tab-example"
                  className="mb-5 profile_tabbber"
                  activeKey={tabkey}
                  fill
                  onSelect={changeTabKey}
                >
                  <Tab eventKey="profile" title="Profile">
                    <h2>My Profile</h2>
                    <div className="my_account_form">
                      <Form onSubmit={updateUserDetails}>
                        <Form.Group
                          className="mb-3 accnt_form"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>Name *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Name"
                            className="accnt_field"
                            name="name"
                            onChange={(e) => {
                              setName(e.target.value);
                            }}
                            required
                            value={name}
                          />
                        </Form.Group>

                        <Form.Group
                          className="mb-3 accnt_form accnt__bg"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>Email *</Form.Label>
                          <div className="accnt_field p-2">{email}</div>
                        </Form.Group>
                        <Form.Group
                          className="mb-3 accnt_form"
                          controlId="formBasicEmail"
                        >

                          <Form.Group
                            className="mb-3 accnt_form"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>User Name</Form.Label>
                            <div className="accnt_field p-2">{userName}</div>
                          </Form.Group>
                          <Form.Label>Phone *</Form.Label>
                          <Form.Control
                            type="tel"
                            placeholder="Enter Phone"
                            className="accnt_field"
                            name="phone"
                            required
                            value={phone}
                            onChange={(e) => {
                              setPhone(e.target.value);
                            }}
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3 accnt_form"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>Address *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Address"
                            className="accnt_field"
                            name="address"
                            required
                            value={address}
                            onChange={(e) => {
                              setAddress(e.target.value);
                            }}
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3 accnt_form"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>City *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter City"
                            className="accnt_field"
                            value={city}
                            onChange={(e) => {
                              setCity(e.target.value);
                            }}
                            required
                            name="city"
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3 accnt_form"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>State *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter State"
                            className="accnt_field"
                            value={state}
                            onChange={(e) => {
                              setState(e.target.value);
                            }}
                            required
                            name="state"
                          />
                        </Form.Group>

                        {/* <Form.Group
                    className="mb-3 accnt_form"
                    controlId="formBasicEmail"
                  >
                    <Form.Label>State *</Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Enter State"
                      className="accnt_field"
                    />
                  </Form.Group> */}

                        <Form.Group
                          className="mb-3 accnt_form"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>Zip Code *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Zip Code"
                            className="accnt_field"
                            value={zipCode}
                            onChange={(e) => {
                              setZipCode(e.target.value);
                            }}
                            required
                            name="zipCode"
                          />
                        </Form.Group>

                        <Form.Group
                          className="mb-3 accnt_form"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>Country *</Form.Label>
                          <Form.Control
                            as="select"
                            className="modal_t_field"
                            required
                            onChange={(e) => {
                              setCountry(e.target.value);
                            }}
                          >
                            {countryConfig.map((value, key) => {
                              return (
                                <option
                                  key={key}
                                  value={value.key}
                                  selected={country === value.key}
                                >
                                  {value.label}
                                </option>
                              );
                            })}
                          </Form.Control>
                        </Form.Group>
                        <Button
                          variant="primary"
                          type="submit"
                          className="accnt_submitt"
                        >
                          Update
                        </Button>
                      </Form>
                    </div>
                  </Tab>

                  <Tab eventKey="password" title="Password">
                    <h2>Change Password</h2>
                    <div className="change_pass_section">
                      <Form onSubmit={updatePassword}>
                        <Form.Group
                          className="prf_inner_pay"
                          controlId="formBasicEmail"
                        >
                          <Form.Label>New Password*</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Enter Password"
                            className="prf_pay"
                            name="new_pass"
                            value={new_pass}
                            required
                            onChange={(e) => {
                              setNewPass(e.target.value);
                            }}
                          />
                        </Form.Group>

                        <Form.Group
                          className="prf_inner_pay"
                          controlId="formBasicPassword258"
                        >
                          <Form.Label>Confirm New Password*</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Enter Password"
                            className="prf_pay"
                            name="con_pass"
                            value={con_pass}
                            required
                            onChange={(e) => {
                              setConPass(e.target.value);
                            }}
                          />
                          <p className="text-danger">{changePassError}</p>
                        </Form.Group>
                        <Button
                          variant="primary"
                          type="submit"
                          className="prf_submi_button"
                        >
                          Change Password
                        </Button>
                      </Form>
                    </div>
                  </Tab>

                  {menuPermission?.escape_credits && (
                    <Tab eventKey="escape" title="Escape Credits">
                      <h2>Escape Credits</h2>
                      <div className="change_pass_section text-center">
                        <div className="account-balance-bar">
                          <Row className="align-items-center w-100 m-0">
                            {/* Left Icon */}
                            <Col
                              xs={2}
                              className="d-flex justify-content-center"
                            >
                              <div className="balance-icon">
                                <img
                                  src={Dollars_Escape_Credits_white}
                                  width={200}
                                  alt=""
                                  srcset=""
                                />
                              </div>
                            </Col>

                            {/* Center Text */}
                            <Col xs={8} className="text-center">
                              <div className="balance-title">
                                Account Balance
                              </div>
                              <div className="balance-amount">
                                {escapeBuckTotalAmount} credits
                              </div>
                            </Col>

                            {/* Right Action */}
                            <Col xs={2} className="text-end pe-4">
                              <p
                                className="balance-transfer"
                                onClick={() => {
                                  dispatch(setEscapeBuckRedeemModal(true));
                                }}
                              >
                                Add
                              </p>
                              <span
                                className="balance-transfer mt-3"
                                onClick={() => {
                                  setTransferModalShow(true);
                                }}
                              >
                                Transfer
                              </span>
                            </Col>
                          </Row>
                        </div>
                        {/* Terms */}
                        <div
                          className="terms-link text-center"
                          onClick={() => {
                            window.open(
                              "https://tvi-api.s3.us-east-2.amazonaws.com/Escape_Credits_TandC_transfer.pdf",
                              "_blank",
                            );
                          }}
                        >
                          Terms and Conditions
                        </div>
                        <Row className="mt-4">
                          <Col xs={12} className="text-left">
                            <Row>
                              <Col md={6}>
                                <h5>Transaction History</h5>
                              </Col>
                              <Col md={3}></Col>
                              <Col md={3} className="text-end">
                                <Button
                                  variant="primary"
                                  onClick={handleDownloadCSV}
                                  disabled={!allCals || allCals.length === 0}
                                >
                                  Download CSV
                                </Button>
                                <CSVLink
                                  data={csvData}
                                  headers={csvHeaders}
                                  filename={
                                    "vip-member-transaction-history-" +
                                    moment().format("DDMMYYYY-HHmmss") +
                                    ".csv"
                                  }
                                  className="hidden"
                                  id="csv-download-link"
                                  target="_blank"
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col className="text-end">
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => setShowFilters(!showFilters)}
                                >
                                  {showFilters
                                    ? "Hide Filters"
                                    : "Show Filters"}
                                </Button>
                              </Col>
                            </Row>

                            {showFilters && (
                              <Row className="mb-4">
                                <Col>
                                  <div className="p-3 border rounded bg-light">
                                    <Row className="g-3 align-items-end">
                                      {/* From Date */}
                                      <Col md={3}>
                                        <Form.Group>
                                          <Form.Label>From Date</Form.Label>
                                          <Form.Control
                                            type="date"
                                            value={filters.fromDate}
                                            onChange={(e) =>
                                              setFilters({
                                                ...filters,
                                                fromDate: e.target.value,
                                              })
                                            }
                                          />
                                        </Form.Group>
                                      </Col>

                                      {/* To Date */}
                                      <Col md={3}>
                                        <Form.Group>
                                          <Form.Label>To Date</Form.Label>
                                          <Form.Control
                                            type="date"
                                            value={filters.toDate}
                                            onChange={(e) =>
                                              setFilters({
                                                ...filters,
                                                toDate: e.target.value,
                                              })
                                            }
                                          />
                                        </Form.Group>
                                      </Col>

                                      {/* Transaction Type */}
                                      {/* <Col md={3}>
            <Form.Group>
              <Form.Label>Transaction Type</Form.Label>
              <Form.Select
                className="form-control"
                value={filters.type}
                onChange={(e) =>
                  setFilters({ ...filters, type: e.target.value })
                }
              >
                <option value="">All</option>
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
                <option value="transfer">Transfer</option>
                <option value="redeem">Code Redemption</option>
              </Form.Select>
            </Form.Group>
          </Col> */}

                                      {/* Action Buttons */}
                                      <Col md={3} className="text-end">
                                        <Button
                                          variant="primary"
                                          onClick={filterCallBack}
                                        >
                                          Apply
                                        </Button>

                                        <Button
                                          variant="secondary"
                                          className="ml-2"
                                          onClick={() => {
                                            setFilters(() => ({
                                              fromDate: "",
                                              toDate: "",
                                              type: "",
                                            }));
                                            fetchCalsReset();
                                          }}
                                        >
                                          Reset
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col>
                            <DataTable
                              // title="Transaction History"
                              columns={escapeColumns}
                              data={allCals}
                              highlightOnHover
                              pagination
                              responsive
                              paginationServer
                              paginationTotalRows={escapeTotal}
                              paginationPerPage={escapeLimit}
                              progressPending={loading}
                              customStyles={customStylesForEscape}
                              paginationRowsPerPageOptions={[10, 20, 50]}
                              onChangePage={(newPage) => {
                                setEscapePage(newPage);
                              }}
                              onChangeRowsPerPage={(newLimit) => {
                                setEscapeLimit(newLimit);
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Tab>
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
      <Modal show={modalshow} onHide={handleModalClose}>
        <Modal.Body>
          <div className="modal_close">
            <h3>Are you sure you want to cancel this plan?</h3>
            <Button
              variant="secondary"
              onClick={handleModalClose}
              className="close_buuut"
            ></Button>
          </div>
        </Modal.Body>
        <Modal.Footer className="footer_but">
          <Button
            variant="secondary"
            onClick={handleCancelPlan}
            className="yesbut"
          >
            Yes
          </Button>
          <Button
            variant="primary"
            onClick={handleModalClose}
            className="nobut"
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={modalPlan} onHide={handlePlanModalClose} size="xl">
        <Modal.Body>
          <div className="modal_close">
            <h3>Please choose your plan!</h3>
            <Button
              variant="secondary"
              onClick={handlePlanModalClose}
              className="close_buuut"
            ></Button>
          </div>
          <div className="tvi_member_include">
            {currentPlan.packageName ? (
              <UpdateHirePlan
                products={products}
                currentPackage={currentPlan.packagePrice}
                isStarBenifit={user.isStarBenifit}
              />
            ) : (
              <UpdatePlanLoveTravels
                products={products}
                currentPackage={currentPlan.packagePrice}
                isStarBenifit={user.isStarBenifit}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={successModal} onHide={handleModalCloseSuccess}>
        <Modal.Body>
          <div className="modal_close">
            <h2 className="text-center">Congratulations!</h2>
            <h3>You have successfully updated your new membership plan.</h3>
            <Button
              variant="secondary"
              onClick={handleModalCloseSuccess}
              className="close_buuut"
            ></Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={modalshowUpdate} onHide={handleModalCloseUpdate}>
        <Modal.Body>
          <div className="modal_close">
            <h3>
              You are about to upgrade your TripValet Membership. When you hit
              the confirm button, you will be charged immediately. Are you ready
              to upgrade?
            </h3>
            <Button
              variant="secondary"
              onClick={handleModalCloseUpdate}
              className="close_buuut"
            ></Button>
          </div>
        </Modal.Body>
        <Modal.Footer className="footer_but">
          <Button
            variant="secondary"
            onClick={() => {
              updatePlan();
            }}
            className="yesbut"
          >
            Yes
          </Button>
          <Button
            variant="primary"
            onClick={handleModalCloseUpdate}
            className="nobut"
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      {transferModalShow && (
        <TransferEscapeBucksModal
          show={transferModalShow}
          handleClose={handleCloseTransferModal}
        />
      )}
    </div>
  );
};

export default MyAccount;
